import React, { useEffect, useState, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Col, Row, message } from 'antd';
import moment from 'moment';

import {
  postINovoAtendimento,
  getSolicitacaoConsulta,
  putFinalizarAtendimento,
  getStatusAtendimento,
  getIndicadores,
  getAtendimentoEmAndamento,
} from '../../services';
import { useAuth } from '../../hooks/auth';
import { formatarDataCorrida } from '../../helpers/formatarDataFila';
import { Indicadores } from './Indicadores';
import { Solicitacoes } from './Solicitacoes';
import { Atendimentos } from './Atendimentos';
import { HeaderPainel } from './HeaderPainel';
import * as S from './styles';

export function PainelDeControle() {
  const history = useHistory();
  const location = useLocation();
  const { temPermissao } = useAuth();
  const [dataOperadores, setDataOperadores] = useState([]);
  const [solicitacaoPesquisas, setSolicitacaoPesquisas] = useState([]);
  const [spinningOperatorAssis, setSpinningOperatorAssis] = useState(false);
  const [spinningReqConsultation, setSpinningReqConsultation] = useState(false);
  const [spinningIndicadores, setSpinningIndicadores] = useState(false);
  const [loadingInitAtendimento, setLoadingInitAtendimento] = useState(false);
  const [loadingAtendimentoEmAndamento, setLoadingAtendimentoEmAndamento] =
    useState(!location.state);
  const [atendimentoEmAndamento, setAtendimentoEmAndamento] = useState(
    location.state?.idTipoValidacao === 1 ? location.state : null
  );
  const [isAdministrador, setIsAdministrador] = useState(false);
  const [indicadoresAnalise, setIndicadoresAnalise] = useState({});
  const [indicadoresResponse, setIndicadoresResponse] = useState({});
  const [atualizar, setAtualizar] = useState(0);
  const canPrioritizeRequest = temPermissao(['PriorizarSolicitacao']);

  const iniciarAtendimento = async () => {
    if (atendimentoEmAndamento) {
      return history.push('/atendimento');
    }

    try {
      setLoadingInitAtendimento(true);
      const { data } = await postINovoAtendimento();
      if (data) {
        setLoadingInitAtendimento(false);
        history.push('/atendimento');
      }
    } catch (error) {
      setLoadingInitAtendimento(false);
      return message.error(
        error?.response?.data?.detail || 'Não foi possivél iniciar atentimento.'
      );
    }
  };

  const carregarAtendimentoEmAndamento = async () => {
    setLoadingAtendimentoEmAndamento(true);
    const { data } = await getAtendimentoEmAndamento();

    setAtendimentoEmAndamento(data?.idTipoValidacao === 1 ? data : null);
    setLoadingAtendimentoEmAndamento(false);
  };

  const listaSolicitacaoConsulta = async () => {
    setSpinningReqConsultation(true);
    const { data } = await getSolicitacaoConsulta();

    setSolicitacaoPesquisas(data?.items || []);
    setSpinningReqConsultation(false);
  };

  const atendimentosOperadorLista = async () => {
    setSpinningOperatorAssis(true);
    const { data } = await getStatusAtendimento();

    if (data?.usuariosAtendimentos) {
      setSpinningOperatorAssis(false);
      return setDataOperadores(data?.usuariosAtendimentos || []);
    }

    return setSpinningOperatorAssis(false);
  };

  const carregarIndicadores = async () => {
    setSpinningIndicadores(true);

    const { data } = await getIndicadores();
    if (data) {
      setIndicadoresResponse(prev => ({ ...prev, ...data }));
    }

    setSpinningIndicadores(false);
  };

  const formatedTempoMaxAnalise = (data = []) => {
    const listDuracao = data
      ?.filter(item => item?.status === 'Analisando' && item?.idAtendimento)
      ?.map(x => x?.tempoAtendimento)
      ?.sort((a, b) => moment(a) > moment(b))[0];

    return listDuracao;
  };

  const gerarIndicadores = useCallback((data = []) => {
    const filtrarStatusAnalisando = data?.filter(item => item?.status === 'Analisando');

    const maxAtendimento = formatedTempoMaxAnalise(data);

    const indicadoresItens = {
      emAnalise: filtrarStatusAnalisando?.length,
      atendimentoMax: formatarDataCorrida(maxAtendimento),
    };
    return setIndicadoresAnalise(indicadoresItens);
  }, []);

  const finalizarAtendimento = async payload => {
    try {
      await putFinalizarAtendimento(payload);
      await atendimentosOperadorLista();
      await listaSolicitacaoConsulta();
      await carregarIndicadores();
      message.success('Atendimento encerrado com sucesso');
    } catch (error) {
      message.error(error.response.data.detail);
    }
  };

  const gerarIndicadoresSolicPendentesAnalise = solicitacoesPendentes => {
    const now = moment();
    const totalSolicitacoes = solicitacoesPendentes.length;

    if (totalSolicitacoes === 0) return;

    const tempos = solicitacoesPendentes.map(solicitacao => {
      const dataEntradaFila = moment(
        solicitacao.dataEntradaFila || solicitacao.dataCadastro
      );

      if (solicitacao.dataSaidaFila) {
        return moment(solicitacao.dataSaidaFila).diff(
          dataEntradaFila,
          'seconds'
        );
      }

      return now.diff(dataEntradaFila, 'seconds');
    });

    const tempoMaximo = Math.max(...tempos);
    const tempoMedio = tempos.reduce((a, b) => a + b, 0) / totalSolicitacoes;

    const formatDuration = totalSeconds => {
      const duration = moment.duration(totalSeconds, 'seconds');
      const days = Math.floor(duration.asDays())
        .toString()
        .padStart(2, '0');
      const hours = duration
        .hours()
        .toString()
        .padStart(2, '0');
      const minutesPart = duration
        .minutes()
        .toString()
        .padStart(2, '0');
      const seconds = duration
        .seconds()
        .toString()
        .padStart(2, '0');
      const milliseconds = duration
        .milliseconds()
        .toString()
        .substring(0, 3);

      let formatedDuration = `${hours}:${minutesPart}:${seconds}.${milliseconds}`;

      if (Number(days) > 0) {
        formatedDuration = `${days}.${formatedDuration}`;
      }

      return formatedDuration;
    };

    const indicadores = {
      quantidadeSolicitacaoAguardandoAtendimentoInterno: totalSolicitacoes,
      tempoMaximoSolicitacaoAguardandoAtendimentoInterno: formatDuration(
        tempoMaximo
      ),
    };

    setIndicadoresResponse(prev => ({ ...prev, ...indicadores }));

    return indicadores;
  };

  useEffect(() => {
    gerarIndicadores(dataOperadores);
  }, [dataOperadores, solicitacaoPesquisas, gerarIndicadores]);

  useEffect(() => {
    if (atualizar === 0) {
      listaSolicitacaoConsulta();
      atendimentosOperadorLista();
      carregarIndicadores();
      carregarAtendimentoEmAndamento();
    }
  }, [atualizar]);

  useEffect(() => {
    const isAdmin = temPermissao(['MenuPainelControle']);
    setIsAdministrador(isAdmin);
  }, [temPermissao]);

  useEffect(() => {
    if (atualizar === 3) setAtualizar(0);
    const timeout = setTimeout(() => {
      setAtualizar(atualizar => atualizar + 1);
    }, 60000);
    return () => clearTimeout(timeout);
  }, [atualizar]);

  useEffect(() => {
    gerarIndicadoresSolicPendentesAnalise(solicitacaoPesquisas);
  }, [solicitacaoPesquisas]);

  return (
    <S.Wrapper id="wrapper">
      <Row>
        <Col span={24}>
          <HeaderPainel
            handelerClick={iniciarAtendimento}
            loadingBtn={
              loadingInitAtendimento || loadingAtendimentoEmAndamento
            }
            isDasabled={
              !atendimentoEmAndamento && !solicitacaoPesquisas?.length
            }
            atendimentoEmAndamento={!!atendimentoEmAndamento}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Indicadores
            indicAnalise={indicadoresAnalise}
            indicResponse={indicadoresResponse}
            spinningIndicadores={spinningIndicadores}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="painel-listas">
        {isAdministrador && (
          <Col xs={24} xl={12}>
            <Card
              title="Solicitações"
              className="painel-list-card"
              id="solicitacaoTest"
            >
              <Solicitacoes
                solicitacoes={solicitacaoPesquisas}
                spinningReqConsultation={spinningReqConsultation}
                listaSolicitacaoConsulta={listaSolicitacaoConsulta}
                canPrioritize={canPrioritizeRequest}
              />
            </Card>
          </Col>
        )}
        <Col xs={24} xl={isAdministrador ? 12 : 24}>
          <Card title="Atendimentos" className="painel-list-card">
            <Atendimentos
              dataOperadores={dataOperadores}
              spinningOperatorAssis={spinningOperatorAssis}
              isAdmin={isAdministrador}
              finalizarAtendimento={finalizarAtendimento}
            />
          </Card>
        </Col>
      </Row>
    </S.Wrapper>
  );
}
